var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ais-search-box", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ currentRefinement, refine }) {
              return [
                _c(
                  "form",
                  {
                    attrs: { autocomplete: "off" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "ci-form--wrapper" }, [
                      _c(
                        "div",
                        {
                          staticClass: "ci-form--group has-leading-icon",
                          class: { populated: currentRefinement.length > 0 },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "ci-form--leading-icon flex-center mdi mdi-magnify",
                          }),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: currentRefinement,
                                expression: "currentRefinement",
                              },
                            ],
                            staticClass: "ci-form--input",
                            attrs: {
                              id: _vm.name,
                              name: _vm.name,
                              type: "text",
                            },
                            domProps: { value: currentRefinement },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  currentRefinement = $event.target.value
                                },
                                function ($event) {
                                  return refine($event.target.value)
                                },
                              ],
                            },
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "ci-form--label",
                              attrs: { for: _vm.name },
                            },
                            [_vm._v(_vm._s(_vm.label))]
                          ),
                          _vm.clearable
                            ? _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center mr-2",
                                },
                                [
                                  _c("ci-button", {
                                    attrs: {
                                      id: "clear-searchbar",
                                      variant: "ghost-light",
                                      icon: "mdi-close",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return refine("")
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }